var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.279,
    height: 65.279,
    viewBox: "0 0 65.279 65.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1768",
    "data-name": "Group 1768",
    transform: "translate(-836.37 -308.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M184.041,393.75a1.29,1.29,0,0,0-.913.378l-4.253,4.253-1.67-1.67a1.292,1.292,0,0,0-1.827,1.827l2.583,2.583a1.292,1.292,0,0,0,1.827,0l5.166-5.166a1.292,1.292,0,0,0-.913-2.2Z",
    transform: "translate(668.179 -35.67)",
    fill: "#004c75",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M185.428,102.646A21.972,21.972,0,0,0,169.58,82.781a11.624,11.624,0,1,0-12.1,0,21.974,21.974,0,0,0-15.847,19.865A11.623,11.623,0,1,0,153.2,119.505a11.6,11.6,0,0,0,20.665,0,11.619,11.619,0,1,0,11.562-16.859ZM154.492,72.873a9.041,9.041,0,1,1,9.041,9.041A9.052,9.052,0,0,1,154.492,72.873ZM163.533,84.5a19.268,19.268,0,0,1,6.185,1.03l-6.185,6.185-6.185-6.185A19.269,19.269,0,0,1,163.533,84.5Zm-20.665,38.748a9.019,9.019,0,1,1,9.041-9.041,9.052,9.052,0,0,1-9.041,9.041Zm9.659-15.5a11.631,11.631,0,0,0-8.306-5.081A19.376,19.376,0,0,1,154.8,86.6c.027.032.038.072.068.1l7.371,7.371v8.582a11.631,11.631,0,0,0-8.367,5.09Zm11.007,15.5a9.019,9.019,0,1,1,9.041-9.041,9.052,9.052,0,0,1-9.041,9.041Zm9.659-15.5a11.63,11.63,0,0,0-8.367-5.09V94.073L172.2,86.7a1.216,1.216,0,0,0,.068-.1,19.376,19.376,0,0,1,10.582,16.066,11.634,11.634,0,0,0-8.306,5.082Zm11.007,15.5a9.036,9.036,0,1,1,9.041-9.041,9.052,9.052,0,0,1-9.041,9.041Z",
    transform: "translate(705.478 247.751)",
    fill: "#004c75",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M463.125,394.125l-4.253,4.253-1.67-1.67a1.292,1.292,0,0,0-1.827,1.827l2.583,2.583a1.292,1.292,0,0,0,1.827,0l5.166-5.166a1.292,1.292,0,0,0-1.827-1.827Z",
    transform: "translate(429.512 -35.666)",
    fill: "#004c75",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M324.041,393.75a1.289,1.289,0,0,0-.913.378l-4.253,4.253-1.67-1.67a1.292,1.292,0,0,0-1.827,1.827l2.583,2.583a1.292,1.292,0,0,0,1.827,0l5.166-5.166a1.292,1.292,0,0,0-.913-2.2Z",
    transform: "translate(548.844 -35.67)",
    fill: "#004c75",
    stroke: "#fff",
    strokeWidth: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.0de13f822290faf46f158cb244febbb6.svg";
export { ForwardRef as ReactComponent };